import { SET_OUTBOUND_ESCALATION_MESSAGE, SET_CLIPBOARD_TEXT, UI_MESSAGES_SET_SHOW_TRANSLATED } from 'actions/types';

const INITIAL_STATE = {
  selectedInbboxTab: null,
  escalationMessage: '',
  chatMacroRecommendationsEnabled: true,
  clipboardText: {},
  outboundEscalationObject: {
    outboundEscalationMessage: '',
  },
  /**
   * Flag that indicates whether to display the original or translated messages.
   */
  showTranslated: false,
};

const messages = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SELECT_INBOX_TAB':
      return Object.assign({}, state, {
        selectedInboxTab: action.tabName,
      });
    // no middleware side effects
    case 'CHANGE_TAB':
      return {
        ...state,
        selectedInboxTab: action.tabName,
      };
    case 'SET_ESCALATION_MESSAGE':
      return Object.assign({}, state, {
        escalationMessage: action.escalationMessage,
      });
    case 'SET_CHAT_MACRO_RECOMMENDATIONS_ENABLED':
      return Object.assign({}, state, {
        chatMacroRecommendationsEnabled: action.chatMacroRecommendationsEnabled,
      });
    case SET_OUTBOUND_ESCALATION_MESSAGE:
      return {
        ...state,
        outboundEscalationObject: action.outboundEscalationObject,
      };
    case SET_CLIPBOARD_TEXT: {
      if (!action.selectedTicketId) {
        return state;
      }

      return {
        ...state,
        clipboardText: {
          ...state.clipboardText,
          [action.selectedTicketId]: action.text,
        },
      };
    }
    case UI_MESSAGES_SET_SHOW_TRANSLATED:
      return {
        ...state,
        showTranslated: action.show,
      };

    default:
      return state;
  }
};

export default messages;
